export default __webpack_public_path__ + "static/media/pwa1000Credits.4c8b1ddd.png";